import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../contexts/authContext";

export const PrivateRouter = ()=>{
    const activeUser = useAuth()
    return (
        activeUser ? <Outlet /> : <Navigate to={"/admin"} />
    )
}